<template>
	<div
		class="CtaGroup"
		:class="[ctaMarginClass, ctaAlignmentClass(ctaAlignment)]"
	>
		<template
			v-for="(button, i) in buttons"
			:key="i"
		>
			<smart-link
				v-if="button.link.url"
				:url="button.link.url"
				class="btn"
				:class="ctaClasses(button)"
				:target="button.target"
				:title="button.title"
				:gtmLabel="button.gtmLabel"
				:gtmAction="button.gtmAction"
				:useVueRoute="button.link.useVueRoute"
				:trackingData="gtmNavigationalTracking(button.title, 'call-to-action', button.link.url)"
				:promotionalTracking="promotionalTracking"
			>
				{{ button.title }}
			</smart-link>
		</template>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue';
	import { gtmNavigationalTracking } from '@/components/utilities/trackingUtility';
	import { ICta } from '@/types/block';

	interface Props {
		buttons: ICta[];
		ctaMarginTop?: string;
		ctaMarginBottom?: string;
		ctaAlignment?: '' | 'left' | 'center' | 'right';
		promotionalTracking?: any;
		usePadding?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		usePadding: false,
	});

	const ctaMarginClass = computed(() => {
		if (props.usePadding) {
			return [
				props.ctaMarginTop !== 'default' ? `pt-${props.ctaMarginTop}` : '',
				props.ctaMarginBottom !== 'default' ? `pb-${props.ctaMarginBottom}` : 'pb-4',
			];
		} else {
			return [
				props.ctaMarginTop !== 'default' ? `mt-${props.ctaMarginTop}` : 'mt-3',
				props.ctaMarginBottom !== 'default' ? `mb-${props.ctaMarginBottom}` : '',
			];
		}
	});

	function ctaClasses(btn: ICta) {
		const btnClassesArr = [];

		if (btn.type) {
			btnClassesArr.push('btn--' + btn.type);
		}

		if (btn.color) {
			btnClassesArr.push('btn--' + btn.color);
		}

		const btnClasses = btnClassesArr.join(' ');
		return btnClasses;
	}

	const ctaAlignmentClass = (alignment: string) => {
		if (alignment === 'left') {
			return 'flex-left';
		}
		if (alignment === 'right') {
			return 'flex-right';
		}
		return 'flex-center';
	};
</script>

<style lang="scss">
	@import './CtaGroup.module.scss';
</style>
